import { gql } from '@apollo/client';

export const DIRECTORY = gql`
  query Directory($id: ID, $slug: String) {
    directory(id: $id, slug: $slug) {
      id
      name
      slug
      values {
        id
        name
        description
        directory
      }
    }
  }
`;

export const DIRECTORIES_VALUES_BY_IDS = gql`
  query DirectoriesValuesByIds($ids: [ID!]!) {
    directoriesValuesByIds(ids: $ids) {
      id
      name
      description
      directory
    }
  }
`;

export const DIRECTORIES = gql`
  query Directory {
    directories {
      id
      name
      slug
    }
  }
`;
